// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xXYh","colBig":"styles_colBig__PcVNi","colSmall":"styles_colSmall__36DsW"};